import { withBasePath } from "@/lib/base-path";

const STORE_LOGOS: Record<string, string> = {
  amazon: "/logos/amazon.png",
  ebay: "/logos/ebay.png",
  walmart: "/logos/walmart.png",
  "best buy": "/logos/best-buy.png",
  target: "/logos/target.png",
  "ninja kitchen": "/logos/ninja-kitchen.png",
};

export function getStoreLogo(store: {
  name: string;
  logo?: string;
}): string | null {
  const local = STORE_LOGOS[store.name.toLowerCase()];
  if (local) return withBasePath(local);
  if (store.logo && /^https?:\/\//.test(store.logo)) return store.logo;
  return null;
}
